export default "__VITE_ASSET__B46z87LM__"